import handleDeepLink from "./handleDeepLinks";

const setupDeepLinks = () => {

// Set up deep link handlers for Cordova
	if (window.cordova) {
		document.addEventListener('deviceready', function () {
			// This will fire when the app is launched via a deep link
			window.handleOpenURL = function (url) {
				console.log("Deep link received deviceready:", url);
				handleDeepLink(url);
			};
		}, false);

		// Handle deep links when app is already running
		document.addEventListener('handleOpenURL', function (event) {
			console.log("Deep link received handleOpenURL:", event?.detail?.url);
			// Store the URL but don't process it yet - wait for resume
			handleDeepLink(event?.detail?.url);
		}, false);

		// Alternative event name for some Cordova versions
		document.addEventListener('handleurl', function (event) {
			console.log("Deep link received handleurl:", event?.detail?.url);
			// Store the URL but don't process it yet - wait for resume
			handleDeepLink(event?.detail?.url);
		}, false);

		// Handle resume event to grab URL when app comes back from background
		document.addEventListener('resume', function (event) {
			console.log('App resumed, event:', event);

			// Try to get the deep link URL from the resume event
			const resumeUrl = event?.detail?.url || event?.url || event?.data?.url;

			if (resumeUrl) {
				console.log('Processing deep link from resume event:', resumeUrl, event);
				handleDeepLink(resumeUrl);
			} else {
				console.log('No deep link URL found in resume event');
			}
		}, false);
	}
}

export default setupDeepLinks;


